import type {ForestMass} from '@/domain/entities/ForestMass';
import type {ForestMassRepository} from '@/domain/interfaces/ForestMassRepository';
import type {HttpClient} from '@/infrastructure/interfaces/HttpClient';
import type {ForestMassDto} from './ForestMassDto';
import {toDomain, toDto} from './ForestMassMappers';

export class RestForestMassRepository implements ForestMassRepository {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly gpkgHttpClient: HttpClient,
  ) {}
  getAll = async () => {
    const forestMasses = await this.httpClient.get<Array<ForestMassDto>>(`forest-masses/`);
    return forestMasses.map((forestMass) => toDomain(forestMass));
  };
  getById = async (uuid: string) => {
    const forestMass = await this.httpClient.get<ForestMassDto>(`forest-masses/${uuid}`);
    return forestMass ? toDomain(forestMass) : undefined;
  };
  patch = async (domain: ForestMass): Promise<ForestMass> => {
    const forestMass = await this.httpClient.patch<ForestMassDto, ForestMassDto>(
      `forest-masses/${domain.uuid}`,
      toDto(domain),
    );
    return toDomain(forestMass);
  };
  download = async (uuid: string): Promise<Blob> => {
    return this.gpkgHttpClient.get<Blob>(`forest-masses/${uuid}`);
  };
}
